import React, { useMemo } from 'react';
import {
  makeStyles,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { injectIntl } from 'react-intl';

import DialogComponent from 'app/components/DialogComponent';

import styles from './styles';
import moment from 'moment';
const useStyles = makeStyles(styles);

function Modal(props) {
  const classes = useStyles();
  const { open, onClose, revision } = props;

  const rows = useMemo(() => {
    if (revision.detalhes) return revision.detalhes;
    return [];
  }, [revision.detalhes]);

  return (
    <DialogComponent title={'Revisão'} open={open} onClose={onClose}>
      <Grid container spacing={1} className={classes.fieldsContainer}>
        <Grid item xs={12} sm={6}>
          Solicitação Anterior nº {revision.nuSolicitacaoAnterior} - {revision.nmServicoAnterior}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.textDark}>
          Solicitação Atual nº {revision.nuSolicitacaoAtual} - {revision.nmServicoAtual}
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.headTableCellDark} align="left">
                  Tipo
                </TableCell>
                <TableCell className={classes.headTableCellDarkField} align="left">
                  Campo
                </TableCell>
                <TableCell className={classes.headTableCellDark} align="left">
                  Valor Anterior
                </TableCell>
                <TableCell className={classes.headTableCellDark} align="left">
                  Valor Atual
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => {
                let oldValue = row.oldValue;
                let newValue = row.newValue;
                let field = row.campo;
                if (row.campo && row.campo.startsWith('dt')) {
                  oldValue = moment.utc(oldValue).format('DD/MM/YYYY');
                  newValue = moment.utc(newValue).format('DD/MM/YYYY');
                } else {
                  if (oldValue.indexOf('<br>') > 0) {
                    oldValue = oldValue.split('<br>');
                  } else {
                    oldValue = [oldValue];
                  }
                  if (newValue.indexOf('<br>') > 0) {
                    newValue = newValue.split('<br>');
                  } else {
                    newValue = [newValue];
                  }
                }
                if (field.indexOf('<br>') > 0) {
                  field = field.split('<br>');
                } else {
                  field = [field];
                }
                return (
                  <TableRow className={classes.tableRow}>
                    <TableCell
                      align="left"
                      className={classes.tableCell}
                      component="th"
                      scope="row"
                    >
                      {row.acao}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      <ul className={classes.list}>
                        {field
                          .filter(value => value !== '')
                          .map(value => {
                            return <li className={classes.listItemNoMargin}>{value}</li>;
                          })}
                      </ul>
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {Array.isArray(oldValue) ? (
                        <ul className={classes.list}>
                          {oldValue
                            .filter(value => value !== '')
                            .map(value => {
                              return <li className={classes.listItem}>{value}</li>;
                            })}
                        </ul>
                      ) : (
                        oldValue
                      )}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {Array.isArray(newValue) ? (
                        <ul className={classes.list}>
                          {newValue
                            .filter(value => value !== '')
                            .map(value => {
                              return <li className={classes.listItem}>{value}</li>;
                            })}
                        </ul>
                      ) : (
                        newValue
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </DialogComponent>
  );
}

export default injectIntl(Modal);
